module.exports = __webpack_public_path__ + "img/Team-MaxZettl.c4038b93.png";